import { EntitiesState } from '@redux/entities'

import type {
  CreateMultipleCampaignQuoteItemsPayload,
  CreateMultipleCampaignQuoteTemplateItemsPayload,
} from '@models/types'

type BuildPublicationOrderParams = {
  campaignId: number,
  campaignQuoteId?: number,
  campaignQuoteTemplateId?: number,
  quoteSectionId?: number,
  redirect?: string,
  selectedCategoryId?: number,
  selectedLiftoverIds: number[],
  selectedProviderId?: number,
  selectedProviderPriceListItemId?: number,
  selectedProviderPriceListItemOptions: object[],
  selectedPublicationEditionIds: number[],
  selectedPublicationId?: number,
  selectedServiceProductId?: number,
  selectedTags: string[],
  serviceProducts: EntitiesState['serviceProducts'],
}

const buildPublicationOrder = (params: BuildPublicationOrderParams) => {
  const {
    campaignId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    quoteSectionId,
    redirect,
    selectedLiftoverIds,
    selectedProviderPriceListItemId,
    selectedProviderPriceListItemOptions,
    selectedPublicationEditionIds,
    selectedPublicationId,
    selectedServiceProductId,
    selectedTags,
    serviceProducts,
  } = params

  const options = {
    campaignId,
    campaignQuoteId,
    quoteSectionId,
    redirect,
  }

  // Quote Item
  if (campaignQuoteId || campaignQuoteTemplateId){
    const selectedServiceProduct = selectedServiceProductId && serviceProducts[selectedServiceProductId]
      ? serviceProducts[selectedServiceProductId]
      : {}

    const payload: CreateMultipleCampaignQuoteItemsPayload | CreateMultipleCampaignQuoteTemplateItemsPayload = {
      campaign_quote_id: undefined,
      campaign_quote_section_id: undefined,
      // @ts-expect-error TS2322
      campaign_quote_template_id: undefined,
      // @ts-expect-error TS2322
      campaign_quote_template_section_id: undefined,
      data: {
        tags: selectedTags,
      },
      item_type: 'orderable',
      // @ts-expect-error TS2322
      options: selectedProviderPriceListItemOptions,
      price_list_item_id: selectedProviderPriceListItemId,
      product_unlock_ids: selectedLiftoverIds,
      publication: {
        // @ts-expect-error TS2322
        id: selectedPublicationId,
      },
      publication_edition_ids: selectedPublicationEditionIds,
      // @ts-expect-error TS2339
      title: selectedServiceProduct.title,
    }

    // Quote
    if (campaignQuoteId){
      // @ts-expect-error TS2339
      payload.campaign_quote_id = campaignQuoteId
      // @ts-expect-error TS2339
      payload.campaign_quote_section_id = quoteSectionId
    }

    // Quote Template
    if (campaignQuoteTemplateId){
      // @ts-expect-error TS2339
      payload.campaign_quote_template_id = campaignQuoteTemplateId
      // @ts-expect-error TS2339
      payload.campaign_quote_template_section_id = quoteSectionId
    }

    return {
      itemType: campaignQuoteTemplateId ? 'quoteTemplateItem' : 'quoteItem',
      options,
      payload,
      redirect,
    }
  }

  // Order
  return {
    itemType: 'order',
    options,
    payload: {
      campaign_id: campaignId,
      order_type: 'publication',
      item: {
        price_list_item: {
          id: selectedProviderPriceListItemId,
        },
        publication: {
          id: selectedPublicationId,
        },
        publication_editions: selectedPublicationEditionIds,
        product_unlocks: selectedLiftoverIds,
        options: JSON.stringify(selectedProviderPriceListItemOptions),
        data: JSON.stringify({
          tags: selectedTags,
        }),
      },
    },
    redirect,
  }
}

export type BuildPublicationOrderPayload = ReturnType<typeof buildPublicationOrder>

export default buildPublicationOrder
